import { sessionState } from "@/state"
import router from "@/router"
import { workflowService } from "@/service"
import FinishFlowAction from "@/action/actions/FinishFlowAction"
import FinishType from "@/model/flow/FinishType"
import { EventDispatcher } from "@/service/EventDispatcher"

function shouldStartNewTimeout(path) {
    return !path.startsWith("/finish") && !path.startsWith("/idle")
}

class SessionService {
    eventDispatcher = new EventDispatcher()
    warnCountdownMillis = null
    timeoutAfterMillis = null
    resetAfterMillis = null
    warnAfterTimer = null
    sessionTimeoutTimer = null
    temporaryTimeoutMillis = null

    constructor() {
        this.updateTimeoutsFromSession()
    }

    resetSessionTimeout() {
        this.updateTimeoutsFromSession()
        this.clearAllTimers()
        this.eventDispatcher.dispatchEvent(new Event("resetTimeout"))
        this.setNewSessionTimeout()
    }

    updateTimeoutsFromSession() {
        this.warnCountdownMillis = sessionState.session.warnCountdownMillis || 30000
        this.timeoutAfterMillis = sessionState.session.timeoutAfterMillis || 600000
        this.resetAfterMillis = this.temporaryTimeoutMillis || this.timeoutAfterMillis
    }

    clearTemporaryTimeoutMillis(reset = true) {
        this.temporaryTimeoutMillis = null
        if (reset) this.resetSessionTimeout()
    }

    setMinTimeoutMillis(millis, reset = true) {
        this.setTemporaryTimeoutMillis(Math.max(millis, this.timeoutAfterMillis), reset)
    }

    setTemporaryTimeoutMillis(millis, reset = true) {
        this.temporaryTimeoutMillis = millis
        if (reset) this.resetSessionTimeout()
    }

    setNewSessionTimeout() {
        if (shouldStartNewTimeout(router.currentRoute.path)) {
            clearTimeout(this.warnAfterTimer)
            this.controlResetSessionTimer("stop")
            const that = this
            this.warnAfterTimer = setTimeout(function() {
                that.controlResetSessionTimer("start")
                that.eventDispatcher.dispatchEvent(new Event("showSessionTimeoutModal"))
            }, Math.max(0, this.resetAfterMillis - this.warnCountdownMillis))
        }
    }

    controlResetSessionTimer(action) {
        switch (action) {
            case "start":
                const that = this
                this.sessionTimeoutTimer = setTimeout(function() {
                    that.clearSession()
                }, this.resetAfterMillis)
                break

            case "stop":
                clearTimeout(this.sessionTimeoutTimer)
                break
        }
    }

    clearAllTimers() {
        clearTimeout(this.warnAfterTimer)
        clearTimeout(this.sessionTimeoutTimer)
    }

    async clearSession(finishType = FinishType.TIMEOUT) {
        this.clearAllTimers()
        await workflowService.invoke(new FinishFlowAction(finishType))
    }

    addEventListener(type, listener) {
        this.eventDispatcher.addEventListener(type, listener)
    }
}

export default SessionService
